<template>
    <div>
        <menu-bar/>
        <div class="container" role="main" v-if="vlan">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li><a :href="'#/'"><i class="fa fa-home" aria-hidden="true"></i> INICIAL</a></li>
                    <li><a :href="'#/vlans'"><i class="fa fa-suitcase" aria-hidden="true"></i> VLANS</a></li>
                    <li class="active">CADASTRO DE VLAN</li>
                </ol>

                <div v-if="!bloco">
                    <go-back  :url="'#/vlans'"/> &nbsp;
                    <button type="button" v-if="user.level === 1"
                            @click="save()" class="btn btn-success">
                        <i class="fa fa-save" aria-hidden="true"></i> SALVAR VLAN
                    </button>
                    <br/><br/>
                </div>

                <form class="form-horizontal" >

                    <div class="panel panel-info" v-if="!bloco">
                        <!-- Default panel contents -->
                        <div class="panel-heading">
                            <i class="fa fa-info-circle" aria-hidden="true"></i> DADOS BÁSICOS
                        </div>

                        <div class="panel-body">
                            <div class="form-group">

                                <div class="col-sm-2">
                                    <label for="numero" class="control-label">NÚMERO DA VLAN</label>
                                    <input id="numero" autocomplete="off" type="text" v-model="vlan.numero" class="form-control" >
                                </div>

                                <div class="col-sm-6">
                                    <label for="nome" class="control-label">NOME DA VLAN</label>
                                    <input id="nome" readonly disabled type="text" v-model="vlan.nome" class="form-control" >
                                </div>

                                <div class="col-sm-4">
                                    <label for="tipo" class="control-label">TIPO</label>
                                    <select id="tipo" v-model="vlan.tipo" class="form-control" >
                                        <option value="CONDOMINIO">CONDOMINIO</option>
                                        <option value="BAIRRO">BAIRRO</option>
                                    </select>
                                </div>

                            </div>

                            <div class="form-group" v-if="vlan.tipo === 'BAIRRO' && vlan.numero">

                                <div class="col-sm-6">
                                    <label for="cidade" class="control-label">CIDADE</label>
                                    <select id="cidade" @change="loadBairros(vlan.street.cidade)" v-model="vlan.street.cidade" class="form-control" >
                                        <option :value="null">ESCOLHA A CIDADE</option>
                                        <option :value="'Campos dos Goytacazes'">CAMPOS DOS GOYTACAZES</option>
                                    </select>
                                </div>

                                <div class="col-sm-6" v-if="vlan.street.cidade && bairros">
                                    <label for="bairro" class="control-label">NOME DA VLAN</label>
                                    <select id="bairro" v-model="vlan.street.bairro" class="form-control" >
                                        <option :value="null">ESCOLHA O BAIRRO</option>
                                        <option v-for="b in bairros.bairros" :key="b.nome" :value="b.nome">{{String(b.nome).toUpperCase()}}</option>
                                    </select>
                                </div>

                            </div>
                        </div>
                    </div>


                    <div class="form-group" >
                        <div class="col-sm-10">
                            <button type="button" v-if="user.level === 1"
                                    @click="save()" class="btn btn-success">
                                <i class="fa fa-save" aria-hidden="true"></i> SALVAR VLAN
                            </button>
                        </div>
                    </div>

                </form>

            </div>

        </div>
    </div>
</template>
<script>
import { Vlan } from "../../../class/vlans";
import { Street } from "../../../class/street";
import GoBack from "../../../components/buttons/goback";

export default {
    components: {
        GoBack
    },
    data() {
        return {
            user: null,
            vlan: null,
            bloco: null,
            nome_pacpon: null,
            bairros: []
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
        if (this.$route.params.id) {
            this.load(this.$route.params.id);
        } else {
            this.vlan = Vlan.create();
        }
    },
    beforeDestroy() {
        console.log("ponto off");
    },
    methods: {
        async load(id) {
            this.vlan = await Vlan.byID(id);
        },
        async loadBairros(cidade) {
            this.bairros = await Street.bairros(cidade);
        },
        save() {
            // eslint-disable-next-line no-undef
            swal.queue([
                {
                    title: "SALVAR",
                    confirmButtonText: "Salvar",
                    text: "Posso salvar o condomínio?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () =>
                        new Promise(resolve => {
                            Vlan.save(this.condominio)
                                .then(() => {
                                    resolve();
                                    this.$router.push({
                                        path: "/vlans"
                                    });
                                })
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        })
                }
            ]);
        }
    }
};
</script>
